module.exports = __webpack_public_path__ + "static/media/file.9444a330.svg";